import React, { useState, useMemo } from 'react';
import { connect } from 'react-redux';
import { IconButton, withStyles, Typography, Tooltip } from '@material-ui/core';
import MaterialTable from 'material-table';
import { Refresh } from '@material-ui/icons';
import { MuiTableRows } from '../../../../themes';
import * as actions from './store/raspberryEraseStationDebugLogsActions';
import * as action from '../../../sc-core/Auth/store/authActions';
import { saveColumnsFilter } from '../../../sc-core/Auth/store/authActions';
import { localization, parseURL } from '../../../sc-utilities';
import Toolbar from '../../../sc-utilities/Toolbar';

const styles = theme => ({
    "@global": {
        "[class*='MuiTableCell-root MuiTableCell-body']": {
            height: "40px",
            padding: "2px",
            fontSize: "0.7rem"
        },
    },
    typography: {
        marginTop: '8%'
    },
    title: {
        marginLeft: 14,
        width: "900px",
    },
    tableTitle: {
        display: "flex",
        flexDirection: "row",
        alignItems: "center",
        overflow: "visible",
        marginTop: "7px",
    },
    customTooltip: {
        marginLeft: -16,
        marginTop: "-2px"
    }
});

let pageSize = 100;
let rowsPageSizeInit = [20, 50, 100];
const RaspberryEraseStationDebugLogsList = props => {
    const searchParams = parseURL(window.location.href);
    const { classes, translations, activeCustomerID, debugLogID, tableColumns, fetchRaspberryEraseStationDebugLogsCount, fetchRaspberryEraseStationDebugLogsList, tableRef } = props;

    const columnObject = useMemo(() => tableColumns, [tableColumns]);
    const [tableOptions, setTableOptions] = useState({
        filtering: true,
        sorting: false,
        search: false,
        minBodyHeight: window.innerHeight - 330 < 300 ? 300 : window.innerHeight - 330,
        maxBodyHeight: window.innerHeight - 330,
        rowStyle: (_rowData, index) => {
            return { backgroundColor: index % 2 ? MuiTableRows.odd : MuiTableRows.even };
        },
        columnsButton: true,
        pageSize: pageSize ? pageSize : 50,
        emptyRowsWhenPaging: false,
    });

    const filterQuery = filters => {
        let obj = {};
        if (searchParams.raspberryEraseStationID) {
            obj['RaspberryEraseStationID'] = searchParams.raspberryEraseStationID;
        }
        for (var filter of filters) {
            obj[filter.column.field] = filter.value;
        }
        return obj;
    }

    async function fetchTableData(query) {
        let q = filterQuery(query.filters);
        query['ActiveCustomerID'] = activeCustomerID;
        query['q'] = q;
        let count = await fetchRaspberryEraseStationDebugLogsCount({ ...query, RaspberryEraseStationID: searchParams.EraseStationID });
        let result = count ? await fetchRaspberryEraseStationDebugLogsList({ ...query, RaspberryEraseStationID: searchParams.EraseStationID }) : [];
        setTableOptions({ ...tableOptions, pageSize: query['pageSize'], pageSizeOptions: rowsPageSizeInit });
        return { data: result, page: query.page, pageSize: pageSize, totalCount: count };
    }

    const columnHidden = newColumnState => {
        let objToSendColumn = {}
        let objColumns = {}
        columnObject.map(column => {
            objColumns[`${column.field}`] = column.hidden;
            return objColumns;
        })
        objToSendColumn[`RaspberryEraseStationDebugLogs`] = objColumns
        saveColumnsFilter({ ...objToSendColumn, activeCustomerID: activeCustomerID, debugLogID: debugLogID })
        return newColumnState
    }

    const tableTitle = () => {
        return <div className={classes.title}>
            <div className={classes.tableTitle}>
                <Typography>{translations["raspberry_erase_station_debug_logs"] || 'Work Dongle debug logs'}</Typography>
                <Tooltip title={translations["refresh"] || "Refresh"}>
                    <IconButton aria-label={translations["refresh"] || "Refresh"} component="div" onClick={() => tableRef.current && tableRef.current.onQueryChange()}>
                        <Refresh />
                    </IconButton>
                </Tooltip>
            </div>
        </div>
    }

    return <>
        <MaterialTable
            components={{
                Toolbar: props => (
                    <Toolbar
                        data={props}
                        selectedRows={props.selectedRows}
                        translations={translations}
                    />
                )
            }}
            localization={localization(translations)}
            tableRef={tableRef}
            title={tableTitle()}
            columns={columnObject}
            data={fetchTableData}
            options={tableOptions}
            onChangeRowsPerPage={(size) => pageSize = size}
            onChangeColumnHidden={columnHidden}
            onChangePage={() => {if(tableRef?.current?.tableContainerDiv?.current) {tableRef.current.tableContainerDiv.current.scrollTop = 0}}}
        />
    </>
}

const mapStateToProps = state => {
    return {
        permissions: state?.core?.login?.permissions || [],
        translations: state.translate && state.translate.translations ? state.translate.translations.activeTranslations || {} : {},
        activeCustomerID: state.core.login.activeCustomer.CustomerID,
        debugLogID: state.core.login.debugLogID,
        raspberryEraseStationDebugLogs: state.statistic.RaspberryEraseStationDebugLogs
    }
}

const mapDispatchToProps = dispatch => {
    return {
        fetchRaspberryEraseStationDebugLogsCount: filter => dispatch(actions.fetchRaspberryEraseStationDebugLogsCount(filter)),
        fetchRaspberryEraseStationDebugLogsList: filter => dispatch(actions.fetchRaspberryEraseStationDebugLogsList(filter)),
        fetchRaspberryEraseStationDebugLogsDownload: filter => dispatch(actions.fetchRaspberryEraseStationDebugLogsDownload(filter)),
        saveColumnsFilter: data => dispatch(action.saveColumnsFilter(data)),
    }
}

export default connect(
    mapStateToProps,
    mapDispatchToProps
)(withStyles(styles, { withTheme: true })(RaspberryEraseStationDebugLogsList));
